import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPencil, faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import './ContractConsult.scss';

import { getRootUrlForUser } from '../../../Helpers/user_helpers';
import { getConsultUrl } from '../../../Helpers/consult_helpers';
import { getShortConsultLink } from '../../../Helpers/attribution_helpers';
import { getPrettyNumber } from '../../../Helpers/formatting';
import { copyToClipboard } from '../../../Helpers/helpers';

const ContractConsult = props => {
  const { contract, consult, canEdit, isPreviewMode } = props;
  const { title, coverImage, analytics, createdAt } = consult;
  const { clicks, volume } = analytics || {};
  const scrollToTop = () => window.scrollTo(0, 0);
  const link = getRootUrlForUser(contract.user) + getConsultUrl(consult);
  const shortLink = getShortConsultLink(consult);
  return (
    <div className='contract-content-element consult'>
      <div className={cn('main', { 'has-shareable-link': canEdit })}>
        <div className='image-container'>{coverImage ? <img src={coverImage} alt={title} /> : <div className='empty-img' />}</div>
        <div className='data'>
          <div className='title'>{title}</div>
          {analytics ? (
            <div className='performance-analytics'>
              {clicks ? `${getPrettyNumber(clicks)} click${clicks === 1 ? '' : 's'}` : ''}
              {volume ? `${clicks ? `, ` : ''}$${getPrettyNumber(volume)} order volume` : ''}
              {!clicks && !volume ? (canEdit ? `Created On ${moment(createdAt).format('MMMM Do')}` : `No click activity yet`) : ''}
            </div>
          ) : (
            <div className='performance-analytics'>Calculating Performance...</div>
          )}
        </div>
      </div>
      <div className='secondary'>
        {canEdit ? (
          <>
            <div className='cell lg short-link'>
              <div className='link'>{shortLink}</div>
              <div className='copy-btn' onClick={() => copyToClipboard(shortLink, true)}>
                Copy
              </div>
            </div>
            {!isPreviewMode && (
              <div className='link-actions'>
                <a href={link} target='_blank' rel='noopener noreferrer' className='link-action link'>
                  <FontAwesomeIcon icon={faExternalLink} />
                </a>
                <Link onClick={scrollToTop} to={getConsultUrl(consult)} rel='noopener noreferrer' className='link-action edit'>
                  <FontAwesomeIcon icon={faPencil} />
                </Link>
                <div onClick={() => props.deleteConsult(consult)} className='link-action delete'>
                  <FontAwesomeIcon icon={faTimes} />
                </div>
              </div>
            )}
          </>
        ) : (
          <div className='link-actions'>
            <a href={link} target='_blank' rel='noopener noreferrer' className='link-action link'>
              <FontAwesomeIcon icon={faExternalLink} />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

ContractConsult.propTypes = {
  consult: PropTypes.object.isRequired,
  contract: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
  deleteConsult: PropTypes.func.isRequired,

  isPreviewMode: PropTypes.bool
};

export default ContractConsult;
